type Event = { name: string };
type EventListener<K extends Event> = { context: any; handler: EventHandler<K> };
type EventHandler<K extends Event> = (event: K) => void;
export class GenericEventEmitter<K extends Event> {
    private listeners: Array<EventListener<K>> = [];
    public on(handler: EventHandler<K>, context?: any) {
        return this.listeners.push({ handler, context });
    }
    public emit(event: K) {
        this.listeners.forEach(listener => {
            listener.handler.call(listener.context, event);
        });
    }
    public off(handler: EventHandler<K>, context?: any) {
        const index = this.listeners.findIndex(
            listener => handler === listener.handler && context === listener.context
        );
        if (index === -1) return false;
        this.listeners.splice(index, 1);
    }
    public removeAllListeners() {
        this.listeners = [];
    }
}
